import React, { Component } from 'react';
import AdminServerActionCreators from 'actions/AdminServerActionCreators';
import EquipmentCsvStore from 'stores/EquipmentCsvStore';
import { withTranslation } from 'react-i18next';
const RECORDS_LIMIT = 1000;
class EquipmentCSVExporter extends Component {
    constructor(props) {
        super(props);
        this.handleButtonClick = () => {
            this.setState({ disabled: !EquipmentCsvStore.isFileDownloaded() });
        };
        this.state = {
            disabled: false,
        };
    }
    componentDidMount() {
        EquipmentCsvStore.addChangeListener(this.handleButtonClick);
    }
    componentWillUnmount() {
        EquipmentCsvStore.removeChangeListener(this.handleButtonClick);
    }
    setDisabled() {
        this.setState({ disabled: true });
    }
    selectActiveColumns() {
        return this.props.columns.filter((e) => e.isShow).map((e) => e.message);
    }
    returnCsv() {
        const activeColumns = this.selectActiveColumns();
        const actionData = {
            filters: this.props.filters,
            limit: RECORDS_LIMIT,
            activeColumns,
        };
        this.setDisabled();
        AdminServerActionCreators.downloadEquipmentCsv(actionData);
    }
    render() {
        return (React.createElement("button", { type: "button", disabled: this.state.disabled, className: "button button-hollow-green", onClick: () => this.returnCsv() },
            React.createElement("i", { className: "fa fa-file-excel-o mr-2" }),
            this.props.t('EXPORT_TO_CSV')));
    }
}
export default withTranslation()(EquipmentCSVExporter);
// EquipmentCSVExporter.propTypes = {
//   filters: React.PropTypes.object.isRequired,
//   columns: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
// };
